import React, { useEffect, useState } from "react";
import { progressService } from "../../../../../../src/services/progressService";
import stars from "../../../../../assets/stars.png";

const UnmetNeedsCard = ({ userId }) => {
  const [unmetNeedsData, setUnmetNeedsData] = useState([]);
  const [selectedCards, setSelectedCards] = useState([]);

  // 🔥 FETCH API INSIDE COMPONENT
  useEffect(() => {
    const fetchUnmetNeeds = async () => {
      if (!userId) {
        console.warn("⚠️ No userId provided!");
        return;
      }

      try {
        console.log("🔥 Fetching unmet needs data for:", userId);

        const res = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "vision",
          "needs_mapping"
        );

        console.log("📥 Full API Response:", res);

        const needs = res?.selectedCardsData || [];

        setUnmetNeedsData(needs);

        // By default select all
        setSelectedCards(needs.map((n) => n.id));
      } catch (err) {
        console.error("❌ Error fetching unmet needs:", err);
      }
    };

    fetchUnmetNeeds();
  }, [userId]);

//   console.log("🧩 Selected Cards:", selectedCards);
//   console.log("🧩 Unmet Needs Data:", unmetNeedsData);

  return (
    <div className="flex flex-col justify-center items-center px-4 py-2 relative overflow-hidden">

      {/* Main Card */}
      <div className="rounded-[22.2px] bg-white max-w-[420px] w-full border border-[#707070] flex flex-col items-center min-h-[500px] relative overflow-hidden">

        {/* Black Header */}
        <div className="bg-[#0D1111] text-white w-full py-6 rounded-t-[22.2px] h-[115px] flex items-center justify-center gap-3">
          <img src={stars} alt="Stars" className="w-6 h-6 rotate-180 opacity-90" />
          <h1 className="text-2xl text-white font-bold font-gotham tracking-wide">
            UNMET NEEDS
          </h1>
          <img src={stars} alt="Stars" className="w-6 h-6 opacity-90" />
        </div>

        {/* Floating First Card */}
        {unmetNeedsData.filter((item) => selectedCards.includes(item.id)).length > 0 && (
          <div className="w-full px-6 -mt-5 z-10">
            <div className="bg-[#F8F8F8] border border-[#CCCCCC] rounded-2xl py-3 px-5 text-center font-gotham font-medium text-[#1D1D1D] shadow-sm">
              {
                unmetNeedsData.filter((item) =>
                  selectedCards.includes(item.id)
                )[0].label
              }
            </div>
          </div>
        )}

        {/* Remaining List */}
        <div className="w-full px-6 pb-8 mt-4">
          {unmetNeedsData
            .filter((item) => selectedCards.includes(item.id))
            .slice(1)
            .map((need) => (
              <div
                key={need.id}
                className="bg-white border border-[#E0E0E0] rounded-2xl py-3 px-5 text-center font-gotham font-medium text-[#1D1D1D] shadow-sm mb-3 hover:bg-[#F8F8F8] transition"
              >
                {need.label}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default UnmetNeedsCard;